
export default function NotFound() {
  return (
	<>
		存在しないページ
	</>
  );
}

